export default "__VITE_ASSET__jBmPBgKz__"